import BaseComponent from "../BaseComponent";
import MinMaxInput from "components/Properties/InputComponents/MinMaxInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";

const EmitterPropertyComponent = ({selectedObject, transformOnChange, dropdownOnChange, dropdownOpened, setDropdownOpened}) => {
  let particleSystem = null;
  let emitAmount = {};
  let emitRate = {};

  if (selectedObject.userData.type === "particleSystem") {
    particleSystem = selectedObject.userData.system;
    emitAmount.min = particleSystem.emitters[0].rate.particlesMin;
    emitAmount.max = particleSystem.emitters[0].rate.particlesMax;
    emitRate.min = particleSystem.emitters[0].rate.perSecondMin;
    emitRate.max = particleSystem.emitters[0].rate.perSecondMax;
  }

  if (selectedObject.name === "ParticleSystem" && particleSystem) {
    return (
      <BaseComponent title="Emitter Property" foldable={true}>
        <DropDownInput
          name="Preset"
          array={["default", "starFountain", "starTunnel", "explosion", "attraction", "smoke", "fire", "fireworks", "rain", "snow"]}
          dropdownOnChange={dropdownOnChange}
          value={particleSystem.presetName}
          selectedObject={selectedObject}
          dropdownOpened={dropdownOpened}
          setDropdownOpened={setDropdownOpened}
        />
        <MinMaxInput name="EmitAmount" value={emitAmount} transformOnChange={transformOnChange} />
        <MinMaxInput name="EmitRate" value={emitRate} transformOnChange={transformOnChange} />
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default EmitterPropertyComponent;
